import styled from 'styled-components';

const Modal = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  position: fixed;
  top: 0;
  left: 0;
  display: flex; 
  align-items: center;
  z-index:20;
  &.solid {
    background: #F1F3F4
  }
`;

export default Modal;
